import React from 'react'

import InviteOrRequestReferralPartners from '@/components/misc/InviteOrRequestReferralPartners/InviteOrRequestReferralPartners'
import InviteTypeChoice from '@/components/modals/InviteToRqModal/InviteTypeChoice'
import { InviteToRqModalStep } from '@/components/modals/InviteToRqModal/types'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useInviteToRqModal } from '@/hooks/useInviteToRqModal'

interface StepDetail {
  title: string
  render: () => React.ReactNode
}

const InviteToRqModal: React.FC = () => {
  const inviteToRqModal = useInviteToRqModal()

  const steps: Record<InviteToRqModalStep, StepDetail> = {
    inviteTypeChoice: {
      title: 'Invite people to RQ',
      render: () => (
        <InviteTypeChoice
          onSelect={(newStep?: InviteToRqModalStep) =>
            newStep ? inviteToRqModal.setStep(newStep) : inviteToRqModal.hide()
          }
        />
      ),
    },

    referralPartners: {
      title: 'Invite your referral partners to RQ',
      render: () => (
        <InviteOrRequestReferralPartners
          initialEmails={inviteToRqModal.emails}
        />
      ),
    },
  }

  const step = steps[inviteToRqModal.step]

  if (!inviteToRqModal.isShowing) {
    return null
  }

  return (
    <Dialog open onHide={inviteToRqModal.hide}>
      <DialogContent className="px-10 pt-6 pb-8 md:min-w-150">
        <DialogHeader>
          <DialogTitle className="text-xl">{step.title}</DialogTitle>
        </DialogHeader>

        <DialogBody>{step.render()}</DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default InviteToRqModal
